import { Exportacao } from '../../../pkw-data/collect/exportacao.model'

export class ErroExportacao {
    constructor(public exportacao: Exportacao, public erros: string[]) {}

    get todosOsErros() {
        return this.erros.join(', ')
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/exportacao-movimento/shared/error-exportacao.ts